import Svg from '../Svg/svg';

export default Svg;